import React, { useState, useEffect } from "react";
import { GiBrokenHeartZone, GiToggles } from "react-icons/gi";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  //navbar scroll when active state
  const [navbar, setNavbar] = useState(false);

  //navbar scroll changeBackground function
  const changeBackground = () => {
    // console.log(window.scrollY);
    if (window.scrollY >= 30) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    changeBackground();
    // adding the event when scroll change background
    window.addEventListener("scroll", changeBackground);
  });

  return (

    <nav className="fixed-top" style={{backgroundColor: (navbar ? "#71c7ec" : "")}}>
      <input type="checkbox" className="myCheckBox" id="myCheck" />
      <label htmlFor="myCheck" className="checkButton">
        <GiToggles/>
      </label>
      <label className="logo">Royal<span style={{color: '#f7c324'}}>X</span></label>
      <ul>
        <li><Link to='#'>Home</Link></li>
        <li><Link to='#'>About</Link></li>
        <li><Link to='#'>Services</Link></li>
        <li><Link to='#'>Contact</Link></li>
      </ul>
    </nav>
  );
};

export default Navbar;
